function initBannerSlider(sectionId){
  const slider = document.querySelector("#banner-slider-" + sectionId);
  if(!slider) return;

  const swiper = new Swiper(slider, {
    loop: true,
    effect: "fade",
    fadeEffect: { crossFade: true },

    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },

    navigation: {
      nextEl: slider.querySelector(".custom-next"),
      prevEl: slider.querySelector(".custom-prev")
    }
  });

  // Play / Pause
  const playBtn = slider.querySelector(".custom-play");

  playBtn.addEventListener("click", function(){
    if(playBtn.dataset.state === "playing"){
      swiper.autoplay.stop();
      playBtn.dataset.state = "paused";
      playBtn.innerHTML = '<i class="fa fa-play"></i>';
    } else {
      swiper.autoplay.start();
      playBtn.dataset.state = "playing";
      playBtn.innerHTML = '<i class="fa fa-pause"></i>';
    }
  });
}

function popUp(url, w, h) {
  window.open(
    url,
    "_blank",
    `toolbar=0,scrollbars=0,location=0,status=0,menubar=0,resizable=1,width=${w},height=${h},left=315,top=262`
  );
}

const clearBtn = document.getElementById('clear-cart-btn');
if(clearBtn) {
  clearBtn.addEventListener('click', function () {
    if (confirm("Are you sure you want to remove all items from your cart?")) {
      fetch('/cart/clear.js', {
        method: 'POST'
      }).then(() => {
        window.location.reload();
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  if (window.location.hash === "#cookie_section") {
    const el = document.querySelector("#cookie_section");
    if (el) {
      setTimeout(() => {
        const topOffset = 150;
        const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - topOffset;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 300);
    }
  }
});

/*
document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.color-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    console.log(swatch.dataset.label);
}, true);
*/

document.addEventListener('click', function (e) {
    const swatch = e.target.closest('.color-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const card = swatch.closest('product-card');
    const productImage = card.querySelector('.product-media img');

    if (productImage) {
        productImage.src = swatch.dataset.image;
        productImage.removeAttribute('srcset');
    }
}, true);

document.addEventListener('DOMContentLoaded', function () {

    const shareBtn = document.querySelector('.share_btn');
    const socialButtons = document.querySelector('.social-share-buttons');

    if (!shareBtn || !socialButtons) {
        return;
    }

    shareBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        socialButtons.classList.toggle('active');
    });

    socialButtons.addEventListener('click', function (e) {
        e.stopPropagation();
    });

    document.addEventListener('click', function () {
        socialButtons.classList.remove('active');
    });

});